import { render } from "./UserItem.vue?vue&type=template&id=93225642&scoped=true"
import script from "./UserItem.vue?vue&type=script&lang=js"
export * from "./UserItem.vue?vue&type=script&lang=js"

import "./UserItem.vue?vue&type=style&index=0&id=93225642&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93225642"]])

export default __exports__